<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
  >
    <g clip-path="url(#clip0_6745_39)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22 0C34.15 0 44 9.85 44 22C44 34.15 34.15 44 22 44C9.85 44 0 34.15 0 22C0 9.85 9.85 0 22 0ZM22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43C33.598 43 43 33.598 43 22C43 10.402 33.598 1 22 1ZM26.978 12V15.964H24.944C23.421 15.964 23.321 16.518 23.321 17.552L23.314 19.536H27L26.569 23.499H23.314V35H18.437V23.499H16V19.536H18.437V17.156C18.437 13.923 19.813 12 23.723 12H26.978V12Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6745_39">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
